import { handleSessionExpiredResponse } from './sessionExpired';

export interface FetchWithSessionHandlingOptions extends RequestInit {
  logout?: () => void;
}

const getCookie = (name: string): string | null => {
  const escapedName = name.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
  const match = document.cookie.match(new RegExp(`(?:^|; )${escapedName}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
};

export const fetchWithSessionHandling = async (
  input: RequestInfo | URL,
  init?: RequestInit,
  options?: FetchWithSessionHandlingOptions,
) => {
  const method = (init?.method ?? 'GET').toUpperCase();
  const isUnsafe = ['POST', 'PUT', 'PATCH', 'DELETE'].includes(method);
  const headers = new Headers(init?.headers ?? {});
  const csrfToken = getCookie('csrf_token');
  if (isUnsafe && csrfToken) {
    headers.set('X-CSRF-Token', csrfToken);
  }

  const requestInit: RequestInit = {
    ...init,
    credentials: init?.credentials ?? 'include',
    headers,
  };

  const response = await fetch(input, requestInit);
  const sessionExpired = await handleSessionExpiredResponse(response, {
    logout: options?.logout,
  });

  return { response, sessionExpired };
};
